const RICOS_VERSION = "10.168.1";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
